import { render, staticRenderFns } from "./ProviderProfileCard.vue?vue&type=template&id=162ef765&scoped=true&"
import script from "./ProviderProfileCard.vue?vue&type=script&lang=js&"
export * from "./ProviderProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ef765",
  null
  
)

export default component.exports